import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { affiliateMemberRequest } from "../actions/affiliates";
import { ClientList } from "../components/ClientList";
import "../resources/stylesheets/clientList.css";
import AffiliateRegisterForm from "../components/AffiliateRegisterForm";
import Notification from "../components/structure/Notification";
import { Overlay } from "clorian-frontend-components";
import { fetchAffiliatesByPos, refreshUser } from "../login/api.actions";
import { NoInfo } from "../components/structure/NoInfo";
import * as type from "../constants/ActionTypes";
import {
  cleanTermsAndConditions,
  fetchTheClientTermsAndConditions,
} from "../actions/termsAndConditions";

class ClientsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClientId: "",
      termsList: null,
      showNotification: false,
      showForm: false,
      notification: {
        status: "",
        message: "",
        title: "",
      },
    };

    this.clientSelect = this.clientSelect.bind(this);
    this.handleRequest = this.handleRequest.bind(this);
  }

  clientSelect(e, client) {
    const { dispatch } = this.props;
    dispatch(cleanTermsAndConditions());

    this.setState({
      selectedClientId: client.clientId,
      showForm: true,
    });

    dispatch(fetchTheClientTermsAndConditions(client.clientId)).then(
      (response) => {
        if (response && response.response) {
          this.setState({
            termsList: response.response,
          });
        }
      }
    );
  }

  handleRequest(formDetails) {
    const { dispatch, intl } = this.props;
    const { selectedClientId } = this.state;

    dispatch(affiliateMemberRequest(selectedClientId, formDetails)).then(
      (response) => {
        if (response && response.type === type.AFFILIATE_MEMBER_SUCCESS) {
          localStorage.setItem("requested_client", selectedClientId);

          dispatch(refreshUser(0)).then(({ response }) => {
            dispatch(fetchAffiliatesByPos());
          });
        } else if (response.type === type.AFFILIATE_MEMBER_FAILURE) {
          const backendMsg = response.error && response.error.message;
          this.setState({
            showNotification: true,
            notification: {
              title: intl.formatMessage({
                id: "affiliate.error.title",
                defaultMessage: "Error",
              }),
              message:
                backendMsg ||
                intl.formatMessage({
                  id: "affiliate.error.message",
                  defaultMessage:
                    "There has been an error in sending the collaboration request.",
                }),
              status: "danger",
            },
            showForm: false,
          });
          console.log("Error notification should be showed");
        }
      }
    );
  }

  componentDidMount() {
    const clientRegistration = localStorage.getItem("clientRegistration");
    const { clientList, showNotification, notification, intl } = this.props;

    if (showNotification) {
      if (notification && notification.status === "success") {
        this.setState({
          showNotification: true,
          notification: {
            title: intl.formatMessage(notification.title),
            message: intl.formatMessage(notification.message),
            status: "success",
          },
          showForm: false,
        });
      } else {
        this.setState({
          showNotification: true,
          notification: {
            title: intl.formatMessage(notification.title),
            message: notification.message,
            status: "danger",
          },
          showForm: false,
        });
      }
    }

    if (clientRegistration && clientList) {
      clientList.every((client) => {
        if (client.clientUrlName === clientRegistration) {
          this.clientSelect(null, client);
          return false;
        }
        return true;
      });
    }
  }

  render() {
    const { clientList, membershipIsProcessing, affiliateList } = this.props;
    const {
      selectedClientId,
      termsList,
      showForm,
      showNotification,
      notification,
    } = this.state;

    let availableClientList = [];

    if (clientList && affiliateList) {
      const enabledClientIds = new Set(
        affiliateList
          .filter((aff) => aff.status === "enabled")
          .map((aff) => aff.affiliate.clientId)
      );

      availableClientList = clientList.filter(
        (cli) => !enabledClientIds.has(cli.clientId)
      );
    } else {
      availableClientList = clientList || [];
    }

    setTimeout(() => {
      if (showForm) {
        let element = document.getElementById("affiliateRegisterForm");
        if (element) {
          element.scrollIntoView({
            block: "center",
            inline: "end",
            behavior: "smooth",
          });
        }
      }
    }, 400);

    return (
      <div className="container">
        <div className="mainBody">
          {availableClientList && availableClientList.length > 0 ? (
            <Fragment>
              {showNotification && <Notification notification={notification} />}

              {membershipIsProcessing ? (
                <Overlay noClorian={true} loading={true} />
              ) : (
                <Fragment>
                  {clientList && affiliateList && (
                    <ClientList
                      clientList={availableClientList}
                      affiliateList={affiliateList}
                      clientSelect={this.clientSelect}
                      selectedClientId={selectedClientId}
                    />
                  )}

                  {selectedClientId !== "" &&
                    showForm &&
                    termsList !== null && (
                      <AffiliateRegisterForm
                        handleRequest={this.handleRequest}
                        termsList={termsList}
                        selectedClientId={selectedClientId}
                      />
                    )}
                </Fragment>
              )}
            </Fragment>
          ) : (
            <NoInfo displayMsg="There are no clients available at this time" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { clients, affiliates } = state;
  return {
    clientList: clients.clientList && clients.clientList,
    membershipIsProcessing: affiliates.membershipIsProcessing,
    affiliateList: affiliates.affiliatesList,
    affiliateClientId: affiliates.clientId,
    showNotification: affiliates.showNotification,
    notification: affiliates.notification,
  };
};

export default connect(mapStateToProps)(injectIntl(ClientsContainer));
